.documentsList {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.loadMore {
  margin-top: 8px;
}

.accordion {
  width: 100%;
  margin-bottom: 24px;
}

.linkList {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}
